import FormOptionCard from '@anwb/poncho/components/form-option-card';
import Tooltip from '@anwb/poncho/components/tooltip';

import { LeaseCarDataPricePoint } from '../../../../../types';
import { formatKilometrageDescription } from '../../../../../utils';
import { trackEvent } from '../../../../../utils/trackEvent';

type KilometrageFullProps = {
	availableKilometrages: LeaseCarDataPricePoint[];
	handleChange: (selectedOptions: string | string[]) => void;
	selectedValue: string;
	customKey: string;
};
export const KilometrageFull = ({
	availableKilometrages,
	handleChange,
	selectedValue,
	customKey,
}: KilometrageFullProps) => (
	<FormOptionCard
		key={`kilometrages-${customKey}`}
		name="kilometrage"
		dataTest="kilometrage"
		inputType="radio"
		columns={2}
		onChange={handleChange}
		preselectedOptions={[selectedValue]}
		required
	>
		{availableKilometrages.map((kilometrage, index) => (
			<FormOptionCard.Item
				key={kilometrage.id}
				label={`${formatKilometrageDescription(kilometrage.description)} km`}
				value={kilometrage.mileage.toString()}
				subTitle={
					kilometrage.pricePerMonth
						? `€ ${kilometrage.pricePerMonth} per maand`
						: 'Geen extra kosten'
				}
				subTitleSize="small"
				{...(availableKilometrages.length - 1 === index && {
					tooltip: (
						<Tooltip
							customTaggingEvent={(_?: string, isOpen?: boolean) => {
								if (isOpen) {
									trackEvent({
										event: 'user_interaction',
										type: 'form',
										component: 'tooltip',
										field: kilometrage.description,
										action: 'click',
										actionValue: 'open',
									});
								}
							}}
						>
							Rijd je meer dan {kilometrage.description.split(' ')[2]} kilometer per jaar? Dan
							betaal je € 0,09 per meer gereden kilometer.
						</Tooltip>
					),
				})}
			/>
		))}
	</FormOptionCard>
);
